
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { fetchLanguageTranslations } from '../store/language-slice';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const langTranslationsWrapper = (WrappedComponent) => {
  return function WithTranslationsWrapper(props) {
    const location = useLocation();
    console.log("location in hoc:", location);
    const dispatch = useDispatch();
    const { documentId } = useParams();
    const translationsMap = location.state?.translationsMap || {};
     useEffect(() => {
        try{
          if(translationsMap && Object.keys(translationsMap).length > 0) return;
          dispatch(fetchLanguageTranslations(documentId));
        }catch(err){
            console.error("Error fetching language translations:", err);
        }
      }, []);
    return <WrappedComponent {...props} translationsMap={translationsMap||{}} />;
  };
};

export default langTranslationsWrapper;

